import React,{useState} from 'react'
import "./App.css";

import { useNavigate } from "react-router-dom";

function AddProductForm(){
const [title,settitle]=useState("");
const [link1,setlink1]=useState("");
const [link2,setlink2]=useState("");
const [image,setimage]=useState("");
const [titleError,settitleError]=useState("");
const [link1Error,setlink1Error]=useState("");
const [link2Error,setlink2Error]=useState("");
const [imageError,setimageError]=useState("");


let navigate = useNavigate();
function handleChange(e){
    setlink2Error("");
    setlink1Error("");
    settitleError("");
    e.preventDefault();
    const {name,value}=e.target;
    if(name==="title")
    settitle(value);
    else if(name==="name"){
    setlink1(value);
    }
    else if(name==="link2"){
        setlink2(value);
    }
}
function handler(events){
    console.log(events.target.files[0])
    const {name,value}=events.target;
    setimageError("");
    if(name==="image"){
        setimage(value);
    }

}
    

function handleSubmit(e){
    e.preventDefault();

    if(title.length<3){
        settitleError("Please Enter a valid title");

    }
    if(!link1.includes("/")){
        setlink1Error("Please Enter a valid link");
    }
    if (!link2.includes("/")){
        setlink2Error("Please Enter a valid link");
        
    }
    else{
        setlink1("");
        settitle("")

        setlink2("");
        navigate('/submitted');
    }
}

    return (
        <div className='main_formdiv'>
            <h2>Enter the following details</h2>
            
            <div className="form">
            <div className='input-container'>
                <input className='name_input' value={title} name="title" type="text" onChange={handleChange}/>
                <label className={title && 'filled'}>Title</label>
               
            </div>
            {titleError && <p style={{color:"red",fontSize:"10px"}}>{titleError}</p>}
            <div className='input-container'>
                <input value={link1} name="name" type="text" onChange={handleChange}/>
                <label className={link1 && 'filled'}>Mobile 3D Model Link</label>
            </div>
            {link1Error && <p style={{color:"red",fontSize:"10px"}}>{link1Error}</p>}
            <div className='input-container'>
                <input value={link2} name="link2" type="text" onChange={handleChange}/>
                <label className={link2 && 'filled'}>Web 3D Model Link</label>
            </div>
            {link2Error && <p style={{color:"red",fontSize:"10px"}}>{link2Error}</p>}
            <br></br>
            <div>
            <div>Upload an image</div>
            <input type="file" name='image' onChange={handler}/>
            </div>
            <button className='submit' onClick={handleSubmit}>Submit</button>
            <p className='abcd'>By Clicking 'Submit' button, the entered data will be finalised and submitted</p>
            </div>
        </div>
    )

}


export default AddProductForm